<script lang="ts">
    export let documentation;
    export let accessLinks;
    export let startDate;
    export let endDate;
    export let detailsLink;
</script>

<div class="row">
    <div class="col mb-2">
        <div class="pt-3">
            <div>
                <h2>Collection Details</h2>
            </div>
            <div>
                <p class="lead">View details about the collection like documentation, types of access, and more.</p>
            </div>
        </div>
    </div>
    <!-- links based on dataset -->
    <div class="col-5">
        <div class="container text-start">
            <div class="row row-cols-2">
                <div class="col">
                    <div class="row mt-4">
                        <div class="col table-border me-4 ps-0 pt-2 mb-2">
                            <small class="text-muted">Documentation</small>
                        </div>
                    </div>
                    {#if documentation}
                        {#each documentation as d}
                            <div class="row mb-3">
                                <div class="col ps-0">
                                    <a href="{d.url}"
                                       class="link"
                                       style="color: #007ec6;"
                                    >
                                        <strong>{d.name}</strong>
                                    </a>
                                </div>
                            </div>
                        {/each}
                    {:else}
                        <div class="row mb-3">
                            <div class="col ps-0">
                                    <strong>N/A</strong>
                            </div>
                        </div>
                    {/if}
                </div>
                <div class="col">
                    <div class="row mt-4">
                        <div class="col table-border me-4 ps-0 pt-2 mb-2">
                            <small class="text-muted">Types of Access</small>
                        </div>
                    </div>
                    {#if accessLinks}
                        {#each accessLinks as a}
                            <div class="row mb-3">
                                <div class="col ps-0">
                                    <a href="{a.url}"
                                       class="link"
                                       style="color: #007ec6;"
                                    >
                                        <strong>{a.name}</strong>
                                    </a>
                                </div>
                            </div>
                        {/each}
                    {:else}
                        <div class="row mb-3">
                            <div class="col ps-0">
                                    <strong>N/A</strong>
                            </div>
                        </div>
                    {/if}
                </div>

                <div class="col">
                    <div class="row mt-1">
                        <div class="col table-border me-4 ps-0 pt-2 mb-2">
                            <small class="text-muted">Period of Record</small>
                        </div>
                    </div>
                    {#if startDate && endDate}
                        <div class="row">
                            <div class="col me-4 ps-0 mb-2">
                                <strong>
                                    {startDate} to {endDate}
                                </strong>
                            </div>
                        </div>
                    {:else}
                        <div class="row">
                            <div class="col me-4 ps-0 mb-2">
                                <strong>
                                    N/A
                                </strong>
                            </div>
                        </div>
                    {/if}
                </div>

                <div class="col">
                    <div class="row mt-1">
                        <div class="col table-border me-4 ps-0 pt-2 mb-2">
                            <small class="text-muted">Collection Information</small>
                        </div>
                    </div>
                    {#if detailsLink}
                        {#each detailsLink as a}
                            <div class="row mb-3">
                                <div class="col ps-0">
                                    <a href="{a.url}"
                                       class="link"
                                       style="color: #007ec6;"
                                    >
                                        <strong>{a.name}</strong>
                                    </a>
                                </div>
                            </div>
                        {/each}
                    {:else}
                        <div class="row mb-3">
                            <div class="col ps-0">
                                <strong>N/A</strong>
                            </div>
                        </div>
                    {/if}
                </div>
            </div>
        </div>
    </div>
</div>
<style>
    .link:link {
        text-decoration: none;
    }

    .link:visited {
        text-decoration: none;
    }

    .link:hover {
        text-decoration: underline;
    }

    .link:active {
        text-decoration: underline;
    }

    .table-border {
        border-top: 1px solid #d1d1d1;

    }
</style>